import { Suspense, lazy } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { ErrorBoundary } from '../common/ErrorBoundary'

const MapContainer = lazy(() =>
  import('./MapContainer').then((module) => ({
    default: module.MapContainer,
  }))
)

interface LazyMapProps {
  center: [number, number]
  zoom?: number
  height?: string | number
  children?: React.ReactNode
  key?: string
  tileUrl?: string
  tileAttribution?: string
}

export function LazyMap({ center, zoom = 13, height = '400px', children, key, tileUrl, tileAttribution }: LazyMapProps) {
  return (
    <ErrorBoundary
      fallback={
        <Box
          sx={{
            height,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
            borderRadius: 1,
          }}
        >
          Map temporarily unavailable
        </Box>
      }
    >
      <Suspense
        fallback={
          <Box
            sx={{
              height,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <MapContainer center={center} zoom={zoom} height={height} tileUrl={tileUrl} tileAttribution={tileAttribution}>
          {children}
        </MapContainer>
      </Suspense>
    </ErrorBoundary>
  )
}
